import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialAuctionState } from "./auction.types";
import { auctionActions } from ".";
import {
  CLEAR_AUCTION,
  CLEAR_AUCTION_STATE,
  FETCH_AUCTION_FAILED,
  FETCH_AUCTION_LINKED_PRODUCT_FAILED,
  FETCH_AUCTION_LINKED_PRODUCT_PROGRESS,
  FETCH_AUCTION_LINKED_PRODUCT_SUCCESS,
  FETCH_AUCTION_LINKED_PRODUCTS_LIST_FAILED,
  FETCH_AUCTION_LINKED_PRODUCTS_LIST_PROGRESS,
  FETCH_AUCTION_LINKED_PRODUCTS_LIST_SUCCESS,
  FETCH_AUCTION_LIST_FAILED,
  FETCH_AUCTION_LIST_PROGRESS,
  FETCH_AUCTION_LIST_SUCCESS,
  FETCH_AUCTION_PRODUCT_FAILED,
  FETCH_AUCTION_PRODUCT_PROGRESS,
  FETCH_AUCTION_PRODUCT_SUCCESS,
  FETCH_AUCTION_PRODUCTS_LIST_FAILED,
  FETCH_AUCTION_PRODUCTS_LIST_PROGRESS,
  FETCH_AUCTION_PRODUCTS_LIST_SUCCESS,
  FETCH_AUCTION_PROGRESS,
  FETCH_AUCTION_SUCCESS,
} from "./auctionActions";

export const auctionReducer = (
  state: IStoreState["auction"] = initialAuctionState,
  action: auctionActions
) => {
  switch (action.type) {
    case FETCH_AUCTION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction.loading = LoadState.InProgress;
        draftState.auction.list = [];
        draftState.auction.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_AUCTION_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction.loading = LoadState.Loaded;
        draftState.auction.list = data;
        draftState.auction.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_AUCTION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.auction.loading = LoadState.InProgress;
        draftState.auction.list = [];
        draftState.auction.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_AUCTION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction.dataLoading = LoadState.InProgress;
        draftState.auction.data = initialAuctionState["auction"]["data"];
      });
      return newState;
    }
    case FETCH_AUCTION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction.dataLoading = LoadState.Loaded;
        draftState.auction.data = data;
      });
      return newState;
    }
    case FETCH_AUCTION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction.dataLoading = LoadState.Failed;
        draftState.auction.error = errorMessage;
      });
      return newState;
    }

 
     case FETCH_AUCTION_PRODUCTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction_product.loading = LoadState.InProgress;
        draftState.auction_product.list = [];
        draftState.auction_product.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_AUCTION_PRODUCTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_product.loading = LoadState.Loaded;
        draftState.auction_product.list = data;
        draftState.auction_product.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_AUCTION_PRODUCTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.auction_product.loading = LoadState.InProgress;
        draftState.auction_product.list = [];
        draftState.auction_product.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_AUCTION_PRODUCT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction_product.dataLoading = LoadState.InProgress;
        draftState.auction_product.data = initialAuctionState["auction_product"]["data"];
      });
      return newState;
    }
    case FETCH_AUCTION_PRODUCT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_product.dataLoading = LoadState.Loaded;
        draftState.auction_product.data = data;
      });
      return newState;
    }
    case FETCH_AUCTION_PRODUCT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_product.dataLoading = LoadState.Failed;
        draftState.auction_product.error = errorMessage;
      });
      return newState;
    }


     case FETCH_AUCTION_LINKED_PRODUCTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction_linked_product.loading = LoadState.InProgress;
        draftState.auction_linked_product.list = [];
        draftState.auction_linked_product.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_AUCTION_LINKED_PRODUCTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_linked_product.loading = LoadState.Loaded;
        draftState.auction_linked_product.list = data;
        draftState.auction_linked_product.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_AUCTION_LINKED_PRODUCTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.auction_linked_product.loading = LoadState.InProgress;
        draftState.auction_linked_product.list = [];
        draftState.auction_linked_product.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_AUCTION_LINKED_PRODUCT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auction_linked_product.dataLoading = LoadState.InProgress;
        draftState.auction_linked_product.data = initialAuctionState["auction_linked_product"]["data"];
      });
      return newState;
    }
    case FETCH_AUCTION_LINKED_PRODUCT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_linked_product.dataLoading = LoadState.Loaded;
        draftState.auction_linked_product.data = data;
      });
      return newState;
    }
    case FETCH_AUCTION_LINKED_PRODUCT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auction_product.dataLoading = LoadState.Failed;
        draftState.auction_product.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_AUCTION:{
      const newState = produce(state,(draftState) => {
        draftState.auction.data = initialAuctionState.auction["data"];
        draftState.auction_product.data = initialAuctionState.auction_product["data"];
        draftState.auction_linked_product.data = initialAuctionState.auction_linked_product["data"];
      });
      return newState;
    }
     case CLEAR_AUCTION_STATE: {
      return initialAuctionState;
    }
    default: {
      return state;
    }
  }
};
